import {create} from 'zustand';

interface ContractTableDeleteFilterModalState {
  deletableId: number | null;

  contractTableDeleteFilterModalOpen: (deletableId: number) => void;
  contractTableDeleteFilterModalClose: () => void;
}

export const useContractTableDeleteFilterModalStore = create<ContractTableDeleteFilterModalState>((set) => ({
  deletableId: null,

  contractTableDeleteFilterModalOpen: (deletableId) => set({deletableId}),
  contractTableDeleteFilterModalClose: () => set({deletableId: null}),
}));

export const {contractTableDeleteFilterModalOpen, contractTableDeleteFilterModalClose} =
  useContractTableDeleteFilterModalStore.getState();
